/**
 * Stage 73.20k — Indian Financial Year (FY) utilities
 *
 * Indian FY runs April 1 to March 31:
 *   - Jan/Feb/Mar  → FY = (year-1)-yy   (e.g. Feb 2026 → FY 2025-26)
 *   - Apr-Dec      → FY = year-(year+1) (e.g. Apr 2026 → FY 2026-27)
 *
 * Hardcoded "FY 2025-26" dropdowns caused production confusion when the
 * user's Apr-2026 period (= FY 26-27 statutorily) could only be computed
 * against the FY 25-26 slabs in the Annual Tax Worksheet UI, producing
 * a different TDS estimate than the Salary Register engine.
 */

/**
 * Indian financial year start month is April (=4).
 */
export const FY_START_MONTH = 4;

/**
 * Get the Indian FY label (e.g. "2026-27") for a given JS Date.
 * Defaults to today.
 */
export const fyLabelForDate = (d = new Date()) => {
  const m = d.getMonth() + 1; // 1-12
  const y = d.getFullYear();
  const startYear = m >= FY_START_MONTH ? y : y - 1;
  const endYY = String(startYear + 1).slice(-2);
  return `${startYear}-${endYY}`;
};

/**
 * Get the Indian FY label for an explicit (month, year) pair.
 * month is 1-12.
 */
export const fyLabelForMonthYear = (month, year) => {
  const startYear = Number(month) >= FY_START_MONTH ? Number(year) : Number(year) - 1;
  return `${startYear}-${String(startYear + 1).slice(-2)}`;
};

/**
 * Current FY label based on system clock.
 */
export const currentFY = () => fyLabelForDate(new Date());

/**
 * Render an array of FY labels for a dropdown.
 * Defaults: current FY +/- 2 years.
 *
 * Example today=Feb-2026 → ["2023-24","2024-25","2025-26","2026-27","2027-28"]
 * Example today=Apr-2026 → ["2024-25","2025-26","2026-27","2027-28","2028-29"]
 */
export const fyDropdownOptions = (yearsBack = 2, yearsForward = 2) => {
  const cur = currentFY();
  const startYear = Number(cur.split('-')[0]);
  const out = [];
  for (let i = -yearsBack; i <= yearsForward; i++) {
    const y = startYear + i;
    out.push(`${y}-${String(y + 1).slice(-2)}`);
  }
  return out;
};

/**
 * For a given FY label like "2026-27", return its [start, end] JS Dates
 * (Apr 1 → Mar 31).
 */
export const fyDateRange = (fyLabel) => {
  const startYear = Number((fyLabel || currentFY()).split('-')[0]);
  return [new Date(startYear, 3, 1), new Date(startYear + 1, 2, 31)];
};
